import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPageUrl } from '../utils/index.ts';
import { User } from '../api/entities.js';
import { Button } from "../components/ui/button.jsx";
import { Input } from "../components/ui/input.jsx";
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from "../components/ui/card.jsx";
import { Label } from "../components/ui/label.jsx";
import { Alert, AlertDescription } from "../components/ui/alert.jsx";
import { ArrowLeft, Building2 } from 'lucide-react';

export default function ClientRecovery() {
  // ... keep existing code (useState, useNavigate) ...

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center gap-2 text-primary">
            <Building2 className="h-6 w-6" />
            <CardTitle>Recuperar Senha</CardTitle>
          </div>
          <CardDescription>
            Enviaremos instruções para recuperar sua senha
          </CardDescription>
        </CardHeader>
        <CardContent>
          {success ? (
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="bg-green-100 p-3 rounded-full">
                  <Building2 className="h-6 w-6 text-green-600" />
                </div>
              </div>
              <h3 className="text-lg font-medium">E-mail enviado!</h3>
              <p className="text-muted-foreground">
                Verifique sua caixa de entrada e siga as instruções para recuperar sua senha.
              </p>
              <Button
                variant="outline"
                className="mt-4"
                onClick={() => navigate(createPageUrl('ClientLogin'))}
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                Voltar para o login
              </Button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {error && (
                <Alert variant="destructive">
                  <AlertDescription>{error}</AlertDescription>
                </Alert>
              )}

              <div className="flex gap-3">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => navigate(createPageUrl('ClientLogin'))}
                >
                  Cancelar
                </Button>
                <Button 
                  type="submit" 
                  className="flex-1 bg-primary"
                  disabled={isLoading}
                >
                  {isLoading ? 'Enviando...' : 'Enviar instruções'}
                </Button>
              </div>
            </form>
          )}
        </CardContent>
        <CardFooter>
          <div className="w-full text-center">
            <p className="text-sm text-muted-foreground">
              Lembrou sua senha?{' '}
              <a 
                href={createPageUrl('ClientLogin')}
                className="text-primary hover:underline"
              >
                Voltar para o login
              </a>
            </p>
          </div>
        </CardFooter>
      </Card>
    </div>
  );
}